export { default } from './Search.vue'



// WEBPACK FOOTER //
// ./src/lib/wind-ui/package/search/index.js